import React from 'react'
import './datablock.css'

const Datablock = ({number, type, span}) => {
  return (
    <div className='dataBlock flex flexCol'>
        <div className="flex flexRow">
            <h2 className="dataNumber">
                {number}
            </h2>
            <h4 className="dataType">
                {type}
            </h4>
        </div>
        <span>
            {span}
        </span>
    </div>
  )
}

export default Datablock